// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Coins as RawCoins } from "lucide-react";
export const Coins = /* @__PURE__ */ createIcon(RawCoins, "Coins", 2);
